module.exports = __webpack_public_path__ + "img/ts_2013.bc5b1d07.jpg";